import {useCallback} from "react";
import {Location} from "react-router-dom";

/**
 * Custom hook for scroll restoration behavior
 * This is used with the ScrollRestoration component from react-router-dom
 * 
 * @returns A callback function that generates a key for scroll restoration
 */
const useScrollRestoration = () => {
    return useCallback((location: Location) => {
        // In newer versions of react-router, we want to use pathname instead of just key
        // to ensure better restoration behavior
        const baseKey = location.key || location.pathname;
        
        // Add query parameters if present for more precise restoration
        if (location.search) {
            return `${baseKey}${location.search}`;
        }
        
        return baseKey;
    }, []);
}

export default useScrollRestoration;